export default __webpack_public_path__ + "static/media/Resume.207f734b.jpg";